import { Col, Form, Input, InputNumber, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import system from "../../../config/systematic";

const { TextArea } = Input;

export default function ExpandDetailEdit(props: any) {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /**单位数据 */
    const [productUnitData, setProductUnitData] = useState<any>();

    /**输入状态 */
    const [inputState, setInputState] = useState<any>(false);

    /**编辑状态 */
    const [editState, setEditState] = useState<any>(false);

    /** 后端数据wmService */
    let wmService = system.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    form.setFieldsValue({ foodName: res.data.menuWarehouse.foodName });
                    form.setFieldsValue({ expandTypeName: res.data.expandType.expandTypeName });
                    if (res.data.amount) {
                        setInputState(true);
                    }
                }
            })
        }
        const fetchData = async () => {
            if (data.type === 'EDIT') {
                setEditState(true);
            }

            fetchApi.GET(wmService, {
                apiId: "productUnit",
                apiExtend: 'showList'
            }).then(res => {
                setProductUnitData(res.data);
            });
        }
        fetchData()
    }, [])

    const handleChange = (e: any) => {
        if (e) {
            setInputState(true);
        }
        else {
            setInputState(false);
            form.setFieldsValue({ productUnitId: null });
        }

    };

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'expandDetail'
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '需求详情'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
            >
                <Form
                    form={form}
                    initialValues={{ "sortBy": 999 }}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="智库菜式"
                                name="foodName">
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="智库菜式Id"
                                name="menuWarehouseId">
                                <Input disabled={editState} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="需求内容"
                                name="expandTypeName">
                                <Input disabled />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="需求内容Id"
                                name="expandTypeId">
                                <Input disabled={editState} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="斤两"
                                name="amount"
                                rules={[{ required: inputState, message: '请输入斤两!' }]}>
                                <InputNumber min={0.01} onChange={handleChange} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="单位"
                                name="productUnitId"
                                rules={[{ required: inputState, message: '请选择单位!' }]}>
                                <Select
                                    showSearch
                                    placeholder="单位"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(productUnitData, 'productUnitName')}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="备注"
                                name="memo">
                                <TextArea
                                    placeholder="备注"
                                    autoSize={{ minRows: 2, maxRows: 5 }}
                                    showCount maxLength={250}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}